import { render, staticRenderFns } from "./PrizeExchangeHistory.vue?vue&type=template&id=2637b27c&scoped=true&"
import script from "./PrizeExchangeHistory.vue?vue&type=script&lang=js&"
export * from "./PrizeExchangeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2637b27c",
  null
  
)

export default component.exports